var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewDay = function SvgViewDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66667 10.1667V9.33333C7.66667 8.875 8.04167 8.5 8.50001 8.5H22.6667C23.125 8.5 23.5 8.875 23.5 9.33333V10.1667C23.5 10.625 23.125 11 22.6667 11H8.50001C8.04167 11 7.66667 10.625 7.66667 10.1667ZM22.6667 12.6667H8.50001C8.04167 12.6667 7.66667 13.0417 7.66667 13.5V18.5C7.66667 18.9583 8.04167 19.3333 8.50001 19.3333H22.6667C23.125 19.3333 23.5 18.9583 23.5 18.5V13.5C23.5 13.0417 23.125 12.6667 22.6667 12.6667ZM8.50001 23.5H22.6667C23.125 23.5 23.5 23.125 23.5 22.6667V21.8333C23.5 21.375 23.125 21 22.6667 21H8.50001C8.04167 21 7.66667 21.375 7.66667 21.8333V22.6667C7.66667 23.125 8.04167 23.5 8.50001 23.5Z",
    fill: "#637381"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewDay.14634a8d.svg";
export { ForwardRef as ReactComponent };